import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme, useAppStyles } from '../theme';
import { useStore } from '../store';
import toast from 'react-hot-toast';

export default function SplashScreen() {
  const C = useTheme();
  const styles = useAppStyles();
  const nav = useNavigate();
  const token = useStore(s => s.token);
  useEffect(() => {
    setTimeout(() => nav(token ? '/home' : '/login'), 2000);
  }, []);

  return (
    <div style={{maxWidth:430, margin:'0 auto', background:C.primary,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:20}}>
      <img src="/vgo-logo.png" alt="VGO" style={{width:90,height:90,objectFit:'contain',filter:'drop-shadow(0 0 24px #6366f155)'}} />
      <div style={{textAlign:'center'}}>
        <div style={{fontSize:36,fontWeight:900,color:C.text,letterSpacing:-1}}>Nexus</div>
        <div style={{fontSize:13,color:C.primary,letterSpacing:3,marginTop:4}}>BY VGO GLOBAL</div>
      </div>
      <div style={{display:'flex',gap:8,marginTop:32}}>
        {[0,1,2].map(i=>(
          <div key={i} style={{width:8,height:8,borderRadius:'50%',background:C.primary,animation:`pulse 1.2s ease ${i*0.2}s infinite`}}/>
        ))}
      </div>
      <style>{`@keyframes pulse{0%,80%,100%{opacity:.3;transform:scale(.8)}40%{opacity:1;transform:scale(1.2)}}`}</style>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// LOGIN SCREEN
// ══════════════════════════════════════════════════════════
